export const getDomain = () =>{
  if(typeof window === "undefined"){
    return "";
  }
    return window?.location?.origin ||"";
}

export const buildApiUrl = (middleware: string = "", endpoint: string, queryParams?: string) => {
    if (!endpoint) {
        console.error('buildApiUrl: endpoint is required');
        return '';
    }
    const domain = getDomain();
    const cleanMiddleware = middleware ? (middleware.startsWith('/') ? middleware : `/${middleware}`) : '';
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    const url = `${domain}${cleanMiddleware}${cleanEndpoint}`;
    return queryParams ? `${url}?${queryParams}` : url;
}


export const extractDomain = () => {
  if (typeof window !== "undefined") {
    let domain = "";

    const url = window.location.origin;
    if (url.includes("localhost") || url.includes("test")) {
      domain = "https://recruiter.foundit.in";
    } else {
      domain = window.location.origin;
    }
    return domain;
  }
  return "";
};

export function extractBaseServer(url: string) {
  if (url.includes("localhost") || url.includes("test")) {
    url = "recruiter.foundit.in";
  }

  const parts = url.split(".");
  const domain = parts[parts.length - 2] + "." + parts[parts.length - 1];

  return domain;
}

export const API_HEADERS = {
  domain: extractDomain(),
  baseServer: extractBaseServer(typeof window !== "undefined" ? window.location.host: ""),
};

export const extraHeaders = (userDetails: any) => {
  return {
    "X-CHANNEL-ID": userDetails?.channel_id || "1",
    "X-Language-Code": "EN",
    "X-SITECONTEXT": userDetails?.site_context || "",
    "X-SUBCHANNEL-ID": userDetails?.subhchannel_id || "1",
  };
};


export function getShortLocationLabel(location: string): string {
  if (!location) return location;
  // Add more patterns as needed
  const patterns: { regex: RegExp; label: string }[] = [
      { regex: /bengaluru\s*\/\s*bangalore/i, label: "Bengaluru" },
      { regex: /hyderabad\s*\/\s*secunderabad.*telangana/i, label: "Hyderabad" },
      { regex: /gurgaon\s*\/\s*gurugram/i, label: "Gurugram" },
  ];

  for (const { regex, label } of patterns) {
      if (regex.test(location)) {
          return label;
      }
  }
  return location;
}